import React, { createContext, useContext, useState } from "react";

const ConsultationContext = createContext({ open: () => {}, close: () => {} });

export function ConsultationProvider({ children, onOpen }) {
  return <ConsultationContext.Provider value={{ open: onOpen }}>{children}</ConsultationContext.Provider>;
}

export function useConsultation() {
  return useContext(ConsultationContext);
}

export default ConsultationContext;
